import { isEmptyObject } from "../../../utils/tests";
import { CompetitionScorersRankingQuery } from '../types';

/**
 * typeguard for CompetitionCalendarAndResultsQuery
 * @param CompetitionScorersRankingQuery object passed to transformer
 */
export const isValidCompetitionTopScorers = (obj: CompetitionScorersRankingQuery): boolean => Boolean(obj?.data?.getCompetitionScorersRanking && !isEmptyObject(obj.data.getCompetitionScorersRanking));
